import { BiSolidError } from "react-icons/bi";
import PrimaryButton from "../Forms/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { resetState, setAuthLogin } from "../../redux/auth/loginSlice";
import { resetCartState } from "../../redux/auth/cartRefreshSlice";
import { resetData } from "../../redux/auth/loginDataSlice";
import { useDispatch } from "react-redux";
import { handleRouteNav } from "../../utils";
import { useApiCall } from "../../services/api";
import { Button } from "antd";

const TermAgreement = ({ isOpen, closeModal, role_id, customer_id }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { postApi } = useApiCall();
  if (!isOpen) return null;
  const handleOverlayClick = (e) => {
    // if (e.target === e.currentTarget) {
    //   closeModal();
    // }
  };

  const acceptAggrement = async () => {
    const payload = {
      customer_id: customer_id,
      is_agree_terms: 1,
    };
    const res = await postApi("customer/agree-terms", payload);

    if (res?.status) {
      closeModal();
      dispatch(setAuthLogin(res.data));
    }
  };

  const navivateOnLogin = () => {
    setTimeout(() => {
      navigate(handleRouteNav("/login", role_id));
    }, 200);
    dispatch(resetState());
    dispatch(resetData());
    dispatch(resetCartState());
  };
  const termpage = () => {
    window.open("/terms-and-conditions");
  };
  const policypage = () => {
    window.open("/privacy-policy");
  };
  return (
    <>
      <div
        onClick={handleOverlayClick}
        id="default-modal"
        className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-40"
      >
        <div className="relative rounded-2xl p-4 w-[500px] model-img max-w-xl max-h-full">
          <div className="p-4">
            <div className="text-[#000] text-left">
              By clicking accept you acknowledge that you have read and agree to our
              <span
                onClick={termpage}
                className=" cursor-pointer underline font-bold font-manrope"
              >
                {" "}
                Terms & Conditions
              </span>{" "}
              &
              <span
                onClick={policypage}
                className="cursor-pointer underline font-bold font-manrope"
              >
                {" "}
                Privacy Policy.
              </span>{" "}
              You must accept in order to continue using our platform. If you do not accept, then
              you may not use our platform.
            </div>
          </div>
          <div className="flex justify-center">
            <PrimaryButton
              btnType={"primary"}
              text={"Accept"}
              onClick={acceptAggrement}
              noIcon
              className=""
              textClassName=" w-[90px]"
            />
          </div>
          <div className="flex justify-center mt-4">
            <button
              onClick={navivateOnLogin}
              className="bg-[#0000009e] hover:bg-[#000000b8] border-none w-[140px] text-[#ffffff]  text-xl
              font-manrope relative font-bold rounded-full text-center h-[42px]"
            >
              Deny
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermAgreement;
